import { render, staticRenderFns } from "./ShowAddress.vue?vue&type=template&id=6580ae19&scoped=true&"
import script from "./ShowAddress.vue?vue&type=script&lang=js&"
export * from "./ShowAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6580ae19",
  null
  
)

export default component.exports